import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { ExclamationDiamondFill } from 'react-bootstrap-icons';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';

import { getAxiosErrorResponse } from '../../api/utils';
import { AuthenticatedContextConsumer } from '../../context/AuthenticatedContext';
import styles from './index.module.scss';

/**
 * ログイン画面
 */
const LoginForm: React.FunctionComponent = () => {
  // 使用するstateを定義
  const [state, setState] = React.useState({
    username: '',
    password: '',
  });
  const [isDisabled, setIsDisabled] = React.useState(false);

  // 変更イベント発生時にstateを変更する
  const handleChange = (name: 'username' | 'password', value: string) => {
    setState({ ...state, [name]: value });
  };

  // 表示内容を返却
  return (
    <AuthenticatedContextConsumer>
      {({ login }) => (
        <Form
          className={`${styles.login} mx-auto`}
          onSubmit={(event) => {
            event.preventDefault();
            setIsDisabled(true);
            login(state)
              .then((res) => {
                setIsDisabled(false);
                return res;
              })
              .catch((error) => {
                const res = getAxiosErrorResponse(error);
                toast.error(() => {
                  return (
                    <>
                      <ExclamationDiamondFill />
                      <span>{` ログイン失敗`}</span>
                      <small>{` (${res?.status ?? '応答なし'})`}</small>
                    </>
                  );
                });
                setIsDisabled(false);
              });
          }}
        >
          <Form.Group controlId="loginCustUserId">
            <Form.Label className={`${styles.titleLabel}`}>
              ユーザーID
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="ユーザーIDを入力してください"
              value={state.username}
              onChange={(event) => {
                handleChange('username', event.target.value);
              }}
              disabled={isDisabled}
            />
          </Form.Group>
          <Form.Group controlId="loginCustUserPassword">
            <Form.Label className={`${styles.titleLabel}`}>
              パスワード
            </Form.Label>
            <Form.Control
              type="password"
              placeholder="パスワードを入力してください"
              value={state.password}
              onChange={(event) => {
                handleChange('password', event.target.value);
              }}
              disabled={isDisabled}
            />
          </Form.Group>
          <>
            <Button variant="primary" type="submit" disabled={isDisabled}>
              ログイン
            </Button>
            <div className="mx-3 d-inline-block align-middle">
              <ClipLoader
                color={styles.loaderColor}
                size={25}
                loading={isDisabled}
              />
            </div>
          </>
        </Form>
      )}
    </AuthenticatedContextConsumer>
  );
};

export default LoginForm;
